import { LoginPage } from './pages/login/login';
import { DashboardPage } from './pages/dashboard/dashboard';
import { GuestdashboardPage } from './pages/guestdashboard/guestdashboard';

export namespace Settings {
        export const appVersion: string = '10.1.0';

        export const privacyPolicyPage: number = 80;
        export const legalPage: number = 81;
        export const contactPage: number = 79;

        export const firebaseConfig = {
            apiKey: "AIzaSyBSt4Y6wpy3LVXZMKnj3kBBAxFoeF9gOIQ",
            authDomain: "teamapp-demo-35d27.firebaseapp.com",
            databaseURL: "https://teamapp-demo-35d27.firebaseio.com",
            projectId: "teamapp-demo-35d27",
            storageBucket: "teamapp-demo-35d27.appspot.com",
            messagingSenderId: "369994776266",
            appId: "1:369994776266:web:a24635adc98b202b2fbe33"
        };

        export const standalone: boolean = false;

        export const customTokenUrl: string = "https://us-central1-teamapp-ff5d6.cloudfunctions.net/getCustomToken";

        export const teamAppApiUrl: string = "https://app.fw-wesling.de/api";
        export const teamAppApiToken: string = "5j3PTCHogyT0YEuG1pIug9zfJTLMMwGv7cdRoMbk6tIZOgpKI1zuy0DfMEVMqf7Zg5kiKLPP6cjEOr8QQV0VsbbJnj211E7EcgrcwXHsmC7skgUGcRvEtE9MwXQFDQOW";

        export const loginDeviceIdSecurity: boolean = false;

        export const homePage   = LoginPage;
        export const afterLoginPage  = DashboardPage;
        export const guestHomePage   = LoginPage;

        export const showJobTitle: boolean   = false;
        /* CHAT */
        export const chatType: string   = 'without-friends';

        /* WORK PLAN */
        export const projectManagerName: string   = 'Chef';
        export const projectCreatorName: string = 'Erfasser';

        export const showProjectCreator: boolean = false;

        /* VACATION */
        export const reasonPlaceholderAdditional: string   = 'Grund (Vertretung)';
        export const reasonPlaceholder: string   = '(Vertretung)';
        export const allowCancel: boolean   = true;
        export const showManager: boolean   = false;
        export const managerName: string   = 'Chef';
        export const maxFuturePlaningDays: number   = 365;
        export const vacationTypes = [
                {name: 'Erholungsurlaub', id: 1},
                {name: 'Sonderurlaub', id: 2},
                {name: 'Urlaub unbezahlt', id: 3},
                {name: 'Überstunden', id: 4},
        ];

        /* CONTACT */
        export const receiverTitle: string   = 'Empfänger';
        export const receiverShow: boolean   = true;

        export const sickReason: boolean   = true;
        export const sickReasonArray: boolean   = true;
        export const sickReasonText: string   = 'wen informiert?';

}

/*
  Tunnel
  _____
 Service
 =(GanzAktuell)"kco-l
 */



// WEBPACK FOOTER //
// ./src/settings.ts